module.exports = __webpack_public_path__ + "img/33.b2c223b7.jpg";